import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/auth/Login.vue";
import Documents from "../components/documents/Documents.vue";
import { getToken } from "../helpers/session";

Vue.use(VueRouter);

const authNotRequiredRoutes = ["Login"];

const routes = [
  {
    path: "/login/",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Documents",
    component: Documents
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  let token = getToken();

  if (authNotRequiredRoutes.indexOf(to.name) == -1 && !token) {
    next({
      name: "Login",
      ...(to.path != "/" ? { query: { redirect: to.path } } : {})
    });
  } else if (authNotRequiredRoutes.indexOf(to.name) >= 0 && token) {
    next({ path: "/" });
  } else {
    next();
  }
});

export default router;
